"use client";
import { Icon, ospThemes } from "@ospweb/sdk-ui";

import { cn } from "utils";
import { ReactNode, useEffect } from "react";
import { useParams } from "next/navigation";
import { DeviceType } from "utils/src/uaDevicesParse/ua-device-parser";
import EdgenDrawer from "../Drawer";
import { preloadImages } from "../LoginSplashGuide/types";

let isPreloaded = false;

const PRELOAD_IMAGES = ["/assets/images/app_login_guide_logo.svg"];
const preloadLoginImages = () => {
  if (typeof window !== "undefined" && !isPreloaded) {
    isPreloaded = true;
    preloadImages(PRELOAD_IMAGES);
  }
};

interface AppFullScreenLoginContentProps {
  className?: string;
  onClose?: () => void;
  children?: ReactNode;
  hideCloseButton?: boolean;
  fullBleed?: boolean;
}
const AppFullScreenLoginContent = ({
  className,
  onClose,
  children,
  hideCloseButton = false,
  fullBleed = false,
}: AppFullScreenLoginContentProps) => {
  const { device } = useParams<{ device: DeviceType }>();
  useEffect(() => {
    preloadLoginImages();
  }, []);

  return (
    <div className={cn("relative w-full h-full", className)}>
      {!hideCloseButton && (
        <Icon
          data-openreplay-label="close"
          name="close"
          size={24}
          color={ospThemes.colors.content_primary}
          className={cn(
            "absolute cursor-pointer z-100",
            "mt-4 left-[16px]",
            (device === "ios" || device === "android") && "fixed-top-safe",
          )}
          onClick={onClose}
        />
      )}

      <div
        className={cn(
          "flex w-full h-full z-10 overflow-x-hidden",
          fullBleed
            ? "flex-col gap-0 px-0 items-stretch overflow-hidden"
            : "safe-area-top flex-col items-center px-4 gap-7 overflow-y-scroll",
        )}
      >
        {children}
      </div>
    </div>
  );
};

interface AppFullScreenLoginModalProps {
  className?: string;
  isOpen: boolean;
  onClose?: () => void;
  children?: ReactNode;
  hideCloseButton?: boolean;
  fullBleed?: boolean;
}

export const AppFullScreenLoginModal = ({
  className,
  isOpen,
  onClose,
  children,
  hideCloseButton = false,
  fullBleed = false,
}: AppFullScreenLoginModalProps) => {
  return (
    <EdgenDrawer
      isOpen={isOpen}
      onClose={onClose}
      placement="bottom"
      width="100%"
      height="100%"
      isHiddenClose={true}
      isMask={true}
      contentClassName="pb-0 no-scrollbar"
      styles={{
        content: {
          borderRadius: 0,
        },
        body: {
          padding: "0 0 0 0",
          borderRadius: "0 0 0px 0px",
          ["scrollbarWidth" as any]: "none",
        },
      }}
    >
      <AppFullScreenLoginContent
        className={className}
        onClose={onClose}
        hideCloseButton={hideCloseButton}
        fullBleed={fullBleed}
      >
        {children}
      </AppFullScreenLoginContent>
    </EdgenDrawer>
  );
};
